import { Component, Prop, Vue } from 'vue-property-decorator';
import { Project } from '@/domain/project/Project';

@Component
export default class ProjectListComponent extends Vue {
  @Prop({ type: Array, required: true })
  readonly items!: Project[];
}
